import styled from "styled-components";

// eslint-disable-next-line import/prefer-default-export
export const CategoryLabel = styled.span`
  text-align: center;
  letter-spacing: 0.45px;
  color: #1070b6;
  background: #a9c8ea 0% 0% no-repeat padding-box;
  font-size: 16px;
  padding: 5px 10px;
  text-transform: uppercase;
`;
